import './vendor';
import './helpers';
import './router';
import Parallax from 'parallax-js';
import {fancybox} from '@fancyapps/fancybox';
import Swiper from 'swiper/js/swiper.js';
import select2 from 'select2';
import inputmask from 'inputmask/dist/jquery.inputmask';
import 'jquery-validation';
import '../../node_modules/jquery-validation/dist/localization/messages_ru.js';
import WOW from 'wow.js';
import helpers from './helpers';
import cursor from './components/cursor';
import scrollbar from './components/scrollbar';

const $document = $(document);
const $window = $(window);
const $html = $('html');

$.validator.addMethod(
	'regex',
	function (value, element, regexp) {
		if (regexp && regexp.constructor != RegExp) {
			regexp = new RegExp(regexp);
		} else if (regexp.global) {
			regexp.lastIndex = 0;
		}

		return this.optional(element) || regexp.test(value);
	},
	'Invalid format',
);

cursor.init();
scrollbar.init();

let app = {
	'global': {
		init() {
			(function (node) {
				let flakeNode = document.querySelector(node);
				let throttle = 0;
				let pos = {x: 0,
					y: 0};

				let tick = function () {
					let prop = `radial-gradient(circle at ${pos.x}px ${pos.y}px, rgba(255,255,255,.8) 0px, rgba(255,255,255,0) 100px);`;
					flakeNode.setAttribute('style', `-webkit-mask-image:${prop}mask-image:${prop}`);
					//requestAnimationFrame(tick);
				};

				window.addEventListener('mousemove', (e) => {
					pos.x = e.pageX;
					pos.y = e.pageY;
					if (!throttle) {
						tick();
						throttle = 1;
					}
					else {
						throttle = 0;
					}

				});

				tick();
			})('.is-flake-overlay');

			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					window.scrollTo(0, $target.offset().top - 125);
				}
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});

			$(function () {
				var currentHash = "#1"
				$(document).scroll(function () {
					$('.anchor').each(function () {
						var top = window.pageYOffset;
						var distance = top - $(this).offset().top + 150;
						var hash = $(this).attr('id');

						if (window.pageYOffset + 150 > $(this).offset().top && window.pageYOffset + 150 < $(this).offset().top + $(this).outerHeight()  && currentHash !== hash) {
							// location.hash = hash;
							history.pushState(null, null, `#${hash}`);
							currentHash = hash;
						}
					});
				});
			});

			$document.on('click', '.buy__item', () => {
				dataLayer.push({
					event: $(e.currentTarget).data('name'),
				});
			});

			let scene = document.getElementById('scene');
			let scene2 = document.getElementById('scene2');
			let scene3 = document.getElementById('scene3');
			let scene4 = document.getElementById('scene4');
			let scene5 = document.getElementById('scene5');
			let scene6 = document.getElementById('scene6');
			let scene7 = document.getElementById('scene7');
			if (scene) {
				let parallax = new Parallax(scene);
			}
			if (scene2) {
				let parallax2 = new Parallax(scene2);
			}
			if (scene3) {
				let parallax3 = new Parallax(scene3);
			}
			if (scene4) {
				let parallax4 = new Parallax(scene4);
			}
			if (scene5) {
				let parallax5 = new Parallax(scene5);
			}
			if (scene6) {
				let parallax6 = new Parallax(scene6);
			}
			if (scene7) {
				let parallax7 = new Parallax(scene7);
			}

			let footerHeight = helpers.$footer.outerHeight(true);
			function bioScroll() {
				footerHeight = helpers.$footer.outerHeight(true);
				let scrollBottom = helpers.$document.height() - (helpers.$window.scrollTop() + helpers.$window.height());

				if (scrollBottom >= footerHeight) {
					$('.bio').css('bottom', '');
					$('.bio').removeClass('is-bottom');
				}
				if (scrollBottom < footerHeight) {
					//$('.bio').css('bottom', `${footerHeight - scrollBottom}px`);
					$('.bio').css('bottom', `${footerHeight}px`);
					$('.bio').addClass('is-bottom');
				}
			}
			helpers.$window.on('scroll', bioScroll);

			new WOW().init();

			$('[data-fancybox]').fancybox({
				backFocus: false,
				touch: false,
				autoFocus: false,
			});
		},
	},
	'header': {
		init($header) {
			$header.find('.header__burger__btn').on('click', (e) => {
				let $drop = $('.header__drop');

				e.preventDefault();
				$html.toggleClass('is-show-burger');
				if ($html.hasClass('is-show-burger')) {
					$drop.stop().slideDown(250);
				} else {
					$drop.stop().slideUp(250);
				}
			});

			$window.on('scroll', () => {
				if ($window.scrollTop() + $('.header').outerHeight()) {
					$html.addClass('is-active-burger');
				} else {
					$html.removeClass('is-active-burger');
				}
			})
		},
	},
	'header-drop': {
		init($header) {
			$header.find('.is-instruction').on('click', (e) => {
				let $this = $(e.currentTarget);
				let $drop = $header.find('.is-instruction-drop');

				e.preventDefault();
				$this.toggleClass('is-active');
				if ($this.hasClass('is-active')) {
					$drop.stop().slideDown(250);
				} else {
					$drop.stop().slideUp(250);
				}
			});
		}
	},
	'topic-mobile': {
		init($header) {
			if (device.mobile()) {
				$header.on('click', () => {
					$header.toggleClass('is-active');
				})
			}
		},
	},
	'output-mobile': {
		init($output) {
			if (device.mobile()) {
				$output.on('click', () => {
					$output.toggleClass('is-active');
				})
			}
		},
	},
	'accordion': {
		init($accordion) {
			let $list = $accordion.find('.accordion__item');
			let $image = $accordion.find('.accordion__image__item');

			$list.on('click', (e) => {
				let $this = $(e.currentTarget);
				let $item = $(`.accordion__image__item[data-item="${$this.data('target')}"]`);

				e.preventDefault();
				if (!$this.hasClass('is-active')) {
					$image.removeClass('is-active');
					$list.removeClass('is-active');
					$item.addClass('is-active');
					$this.addClass('is-active');

					if (device.mobile()) {
						$('html, body').animate({
							scrollTop: $this.offset().top - 100,
						}, 400);
					}
				} else {
					$accordion.find('.accordion__item.is-active').removeClass('is-active');
				}
			});
		},
	},
	'select': {
		init($select) {
			$select.find('select').select2({
				minimumResultsForSearch: $select.data('search') ? 5 : Infinity,
				dropdownParent: $select.find('.input__field'),
			});
		},
	},
	'tabs': {
		init($tabs) {
			let $list = $tabs.find('.tabs__menu ul li a');
			let $items = $tabs.find('.tabs__item');

			$list.on('click', (e) => {
				let $this = $(e.currentTarget);
				let $item = $(`.tabs__item[data-item="${$this.data('target')}"]`);

				e.preventDefault();
				if (!$this.hasClass('is-active')) {
					$items.removeClass('is-active');
					$list.removeClass('is-active');
					$item.addClass('is-active');
					$this.addClass('is-active');
				}
			});
		},
	},
	'form': {
		init($form) {
			let validator = $form.validate({
				lang: 'ru',
				rules: {
					fio: {
						regex: /^[a-zA-Zа-яА-Я\s]+$/ig,
					},
					email: {
						maxlength: 50,
					},
					subject: {
						maxlength: 300,
					},
				},
				messages: {
					fio: {
						regex: 'только буквы',
					},
				},

				submitHandler(form) {
					if ($form.data('type') === 'submit') {
						form.submit();
					} else {
						let preparedData;
						let processData;
						let contentType;

						$form.removeClass('is-sended is-error');

						if ($form.find('input[type="file"]').length > 0) {
							preparedData = new FormData($form.get()[0]);
							processData = false;
							contentType = false;
						}

						$.ajax({
							type: $form.attr('method'),
							url: $form.attr('action'),
							data: preparedData ? preparedData : $form.serialize(),
							dataType: 'json',
							processData,
							contentType,
							success(result) {
								if (result.result === true) {
									$form[0].reset();
									$.fancybox.close();
								}
								$.fancybox.open(`<div class="modal modal--alert">
									${result.message}
								</div>`, {
									touch: false,
									autoFocus: false,
								});
							},
						});
					}
				},
			});
		},
	},
	'gallery': {
		init($gallery) {
			new Swiper($gallery.find('.swiper-container'), {
				spaceBetween: 13,
				breakpoints: {
					375: {
						slidesPerView: 1,
					},
					1280: {
						slidesPerView: 3,
					},
				},
				navigation: {
					prevEl: $gallery.find('.navigation__prev')[0],
					nextEl: $gallery.find('.navigation__next')[0],
				},
			});
		},
	},
	'mask': {
		init($mask) {
			$mask.inputmask($mask.data('mask').toString(), {
				showMaskOnHover: false,
				clearIncomplete: true,
			});
		},
	},
	'stuff': {
		init($stuff) {
			let $list = $stuff.find('.stuff__item__link a');
			let $items = $stuff.find('.stuff__box');

			$list.on('click', (e) => {
				let $this = $(e.currentTarget);
				let $item = $(`.stuff__box[data-item="${$this.data('target')}"]`);

				e.preventDefault();
				if (!$this.hasClass('is-active')) {
					$items.removeClass('is-active');
					$list.removeClass('is-active');
					$item.addClass('is-active');
					$this.addClass('is-active');
				}
			});
		},
	},
	getURLParam(param, url) {
		if (url) {
			return new URL(url).searchParams.get(param);
		}

		return new URL(window.location.href).searchParams.get(param);
	},
	'buy': {
		init($buy) {
			let buyMap;
			let $buyMap = $buy.find('.buy-map');
			let $buyProduct = $buy.find('.but__product');
			let markers = [];
			let filter = [];
			let markersSize = [64, 64];
			let points = [];

			let setChecked = () => {
				let url = new URL(location.href);

				if (url.searchParams.get('filter')) {
					let array = url.searchParams.get('filter').split(',');

					$buy.find('.js-buy-filter-item').prop('checked', false);
					array.forEach(item => {
						$buy.find(`.js-buy-filter-item[value="${item}"]`).prop('checked', true);
					});
					$buy.find('.buy__opt button').removeClass('is-active');
					showItems();
					showProducts();
				}
			}

			$buy.find('.buy__choose__more button').on('click', (e) => {
				let $this = $(e.currentTarget);
				let $drop = $buy.find('.buy__drop');

				e.preventDefault();
				$this.toggleClass('is-active');
				$drop.toggleClass('is-active');
				if ($drop.hasClass('is-active')) {
					$drop.stop().slideDown(250);
				} else {
					$drop.stop().slideUp(250);
				}
			})

			let collectFilter = () => {
				filter = [];

				$buy.find('.js-buy-filter-item:checked').each((index, item) => {
					filter.push($(item).val());
				});
			};

			let showItems = (disabledBounds) => {
				if ($buyMap.length && $buyMap.is(':visible')) {
					buyMap.geoObjects.removeAll();
				}

				if (points.length) {
					$.each(points, (index, item) => {
						collectFilter();
						let show = false;

						if (filter.length) {
							$.each(item.types, (typeIndex, typeItem) => {
								if (filter.indexOf(typeItem) !== -1) {
									show = true;
								}
							});
						}

						if ($buyMap.length && $buyMap.is(':visible')) {
							if (show || filter.length === 0) {
								let MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
									'<div class="popover top">' +
									'<div class="popover-circle"></div>' +
									'<a class="close" href="#">&times;</a>' +
									'<div class="arrow"></div>' +
									'<div class="popover-inner">' +
									'$[[options.contentLayout observeSize minWidth=235 maxWidth=235 maxHeight=350]]' +
									'</div>' +
									'</div>', {
											/**
											 * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
											 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
											 * @function
											 * @name build
											 */
											build: function () {
												this.constructor.superclass.build.call(this);

												this._$element = $('.popover', this.getParentElement());

												this.applyElementOffset();

												this._$element.find('.close')
													.on('click', $.proxy(this.onCloseClick, this));
											},

											/**
											 * Удаляет содержимое макета из DOM.
											 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
											 * @function
											 * @name clear
											 */
											clear: function () {
												this._$element.find('.close')
													.off('click');

												this.constructor.superclass.clear.call(this);
											},

											/**
											 * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
											 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
											 * @function
											 * @name onSublayoutSizeChange
											 */
											onSublayoutSizeChange: function () {
												MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

												if(!this._isElement(this._$element)) {
													return;
												}

												this.applyElementOffset();

												this.events.fire('shapechange');
											},

											/**
											 * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
											 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
											 * @function
											 * @name applyElementOffset
											 */
											applyElementOffset: function () {
												this._$element.css({
													left: -(this._$element[0].offsetWidth / 2),
													top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
												});
											},

											/**
											 * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
											 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
											 * @function
											 * @name onCloseClick
											 */
											onCloseClick: function (e) {
												e.preventDefault();

												this.events.fire('userclose');
											},

											/**
											 * Используется для автопозиционирования (balloonAutoPan).
											 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
											 * @function
											 * @name getClientBounds
											 * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
											 */
											getShape: function () {
												if(!this._isElement(this._$element)) {
													return MyBalloonLayout.superclass.getShape.call(this);
												}

												var position = this._$element.position();

												return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
													[position.left, position.top], [
														position.left + this._$element[0].offsetWidth,
														position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
													]
												]));
											},

											/**
											 * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
											 * @function
											 * @private
											 * @name _isElement
											 * @param {jQuery} [element] Элемент.
											 * @returns {Boolean} Флаг наличия.
											 */
											_isElement: function (element) {
												return element && element[0] && element.find('.arrow')[0];
											}
										}),

									// Создание вложенного макета содержимого балуна.
									MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
										'<h3 class="popover-title">$[properties.balloonHeader]</h3>' +
										'<div class="popover-content">$[properties.balloonContent]</div>'
									);

								let marker = new ymaps.Placemark([item.lat, item.lng], {
									balloonContent: item.text,
								}, {
									balloonShadow: false,
									balloonLayout: MyBalloonLayout,
									balloonContentLayout: MyBalloonContentLayout,
									balloonPanelMaxMapArea: 0,
									hideIconOnBalloonOpen: false,
									iconLayout: 'default#image',
									iconImageHref: $buyMap.data('icon'),
									iconImageSize: [markersSize[0], markersSize[1]],
									iconImageOffset: [markersSize[0] / -2, markersSize[0] / -2],
								});

								marker.events.add('click', () => {
									buyMap.setCenter([item.lat, item.lng]);
									//buyMap.setZoom(17);

									dataLayer.push({
										event: $buyMap.data('logo'),
										eventCategory: $buyMap.data('logo'),
										eventAction: 'click_logo',
										eventLabel: $buyMap.data('label'),
									});
								});

								marker.events.add(['mouseenter', 'mouseleave'], (e) => {
									let type = e.get('type');

									if (buyMap.getZoom() < 16) {
										if (type === 'mouseenter') {
											marker.options.set('iconImageHref', $buyMap.data('icon-active'));
											helpers.$html.addClass('state-custom-cursor-active');
										} else {
											marker.options.set('iconImageHref', $buyMap.data('icon'));
											helpers.$html.removeClass('state-custom-cursor-active');
										}
									} else {
										marker.options.set('iconImageHref', $buyMap.data('icon'));
										helpers.$html.removeClass('state-custom-cursor-active');
									}
								});

								markers.push(marker);
								buyMap.geoObjects.add(marker);

								if (!disabledBounds) {
									if (buyMap.geoObjects.getBounds()) {
										buyMap.setBounds(buyMap.geoObjects.getBounds());
									}
								}

								if (buyMap.getZoom() > 17) {
									buyMap.setZoom(17);
								}
							}
						}
					});
				} else {
					$.fancybox.open(`<div class="modal modal--alert">
									В этом городе нет возможности купить продукты Elance. Выберите другой город или оформите онлайн заказ
								</div>`, {
						touch: false,
						autoFocus: false,
					});
				}
			};

			let showProducts = (showProd) => {
				collectFilter();
				$buy.find('.buy__col').each((index, item) => {
					let show = false;
					let $item = $(item);

					if (filter.length) {
						$.each($item.data('types'), (typeIndex, typeItem) => {
							if (filter.indexOf(typeItem) !== -1) {
								show = true;
							}
						});
					}

					if (show || filter.length === 0) {
						$item.removeClass('is-hidden');
					} else {
						$item.addClass('is-hidden');
					}
				})
			}

			$buyProduct.each((index, item) => {
				let $item = $(item);
				points.push({
					id: $item.data('id'),
					text: $item.data('text'),
					types: $item.data('types'),
					lat: $item.data('lat'),
					lng: $item.data('lng'),
				});
			});

			$buy.find('.js-buy-filter-item').on('change', (e) => {
				let url = new URL(location.href);

				$buy.find('.buy__opt button').removeClass('is-active');
				let array = [];

				$buy.find('.buy__opt_top .js-buy-filter-item').each((index, elem) => {
					if ($(elem).is(':checked')) {
						if (array.indexOf($(elem).val()) === -1) {
							array.push($(elem).val());
						}
					}
				});

				url.searchParams.set('filter', array.join(',') || 'all');
				window.history.pushState('', '', url.href);

				if ($(e.currentTarget).is(':checked')) {
					$buy.find(`.js-buy-filter-item[value="${$(e.currentTarget).val()}"]`).prop('checked', true)
				} else {
					$buy.find(`.js-buy-filter-item[value="${$(e.currentTarget).val()}"]`).prop('checked', false)
				}
				if ($buy.find('.js-buy-filter-item:checked').length === 0) {
					$buy.find('.buy__opt button').addClass('is-active');
				}
				showItems();
				showProducts();
			});

			$buy.find('.buy__opt button').on('click', (e) => {
				let url = new URL(location.href);

				url.searchParams.set('filter', 'all');
				window.history.pushState('', '', url.href);
				$buy.find('.buy__opt button').addClass('is-active');
				$buy.find('.buy__opt label input').prop('checked', false);
				showItems();
				showProducts();
			});

			app.scriptLoading('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
				ymaps.ready(() => {
					let mapSearch = new ymaps.SuggestView('map-search');

					buyMap = new ymaps.Map($buyMap.attr('id'), {
						center: [55.752200, 37.618582],
						zoom: 15,
						controls: [],
					}, {});

					buyMap.controls.add('zoomControl', {
						size: 'small',
						position: {
							top: '258px',
							right: '33px',
						},
					});

					buyMap.events.add('boundschange', (e) => {
						if (e.get('newZoom') !== e.get('oldZoom')) {
							dataLayer.push({
								event: $buyMap.data('zoom'),
								eventCategory: $buyMap.data('zoom'),
								eventAction: 'zoom',
								eventLabel: $buyMap.data('label'),
							});
						}
					})

					buyMap.behaviors.disable('scrollZoom');
					showItems();
					showProducts();

					// buyMap.events.add('boundschange', (e) => {
					// 	let newSize = 124 * e.get('newZoom') / 15 * e.get('newZoom') / 15;
					//
					// 	if (e.get('newZoom') !== e.get('oldZoom')) {
					// 		markersSize = [newSize, newSize];
					// 		showItems(true);
					// 	}
					// });

					$window.on('scroll', () => {
						if ($window.scrollTop() + $('.header').outerHeight() > $buyMap.offset().top) {
							buyMap.behaviors.enable('scrollZoom');
						} else {
							buyMap.behaviors.disable('scrollZoom');
						}
					})
				});
			});

			$buy.on('submit', (e) => {
				e.preventDefault();

				$.ajax({
					type: 'get',
					url: $buy.data('action'),
					data: {
						q: document.getElementById('map-search').value,
					},
					dataType: 'json',
					success(result) {
						dataLayer.push({
							event: $buyMap.data('setregion'),
							eventCategory: $buyMap.data('setregion'),
							eventAction: 'set_region',
							eventLabel: $buyMap.data('label'),
						});
						points = result.items;
						showItems();
					},
				});
			});

			setChecked();

			window.addEventListener('popstate', () => {
				setChecked();
			});
		},
	},
	scriptLoading(src, callback) {
		let script = document.createElement('script');
		let loaded;

		script.setAttribute('src', src);
		if (callback) {
			script.onreadystatechange = script.onload = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	},
	'footer-letter': {
		init($footer) {
			let $list = $footer.find('.footer__letter__drop');

			$footer.find('.btn-letter').on('click', (e) => {
				e.preventDefault();
				$list.addClass('is-active')
				$list.slideDown(250, () => {
					$('html, body').animate({
						scrollTop: $list.offset().top - 100,
					}, 400);
				});
			});

			$footer.find('.footer__letter__btn button').on('click', (e) => {
				e.preventDefault();
				$list.removeClass('is-active');
				$list.slideUp(250);
			});
		},
	},
};

app.global.init();

$('[data-app]').each((index, item) => {
	let $this = $(item);
	let appName = $this.data('app');

	if (app[appName]) {
		app[appName].init($this);
	}
});
